import React from 'react'
import Axios from 'axios'
import Logo from '../img/logo.jpg'
import { INSTA_API_KEY } from "../config.js";



class Feed extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      fetched: [],

    }
  }

  componentDidMount() {
    
      const token = INSTA_API_KEY;
      let num_photos = 4;
      let fullUrl = 'https://api.instagram.com/v1/users/self/media/recent/?access_token=' + token + '&count=' + num_photos
    
      Axios.get(fullUrl)

      .then(res => {
   
        this.setState({ fetched: res.data.data });
        localStorage.setItem('data', res.data.data)
    })

    .catch(err => {
        console.log(err)
    })


  }

  render() {

    

    

      return(
        <div className="my-5 py-5">
          <div className="d-flex flex-row border mb-5 align-items-center justify-content-around flex-wrap">
            <img src={Logo} class="rounded-circle m-5" alt="Complex Logo" />
            <p className="w-50"><strong><a className="text-dark text-decoration-none" href="https://www.instagram.com/complexjiujitsu/" target="_blank" rel="noopener noreferrer">• COMPLEX JIU JITSU •</a></strong><br></br>Brazilian jiu jitsu school founded by 2 creative minds who are trying to make a small difference in the local community <span role="img">🤙🏼</span></p>
            <a href="https://www.instagram.com/complexjiujitsu/"><button className="button-instagram mb-5">Follow</button></a> 
          </div>
          <div className="d-flex flex-row flex-wrap">
          { this.state.fetched.map((data) => {

            let InstaTitle = '';
            let InstaHasTags = '';
            let InstaHasAt = '';
           
           if (data.caption.text.includes('#')) 
           {
            let HashTagKey =  data.caption.text.indexOf('#')
            InstaHasTags = data.caption.text.substring(HashTagKey)
            InstaTitle = data.caption.text.substring (0,HashTagKey)
            if (data.caption.text.includes('@')) 
              {
              let AtTagKey =  data.caption.text.indexOf('@')
              InstaHasAt = data.caption.text.substring(AtTagKey, HashTagKey )
              InstaTitle = data.caption.text.substring (0,AtTagKey)
              }
           }

          return  <div className="col-md-3 d-flex flex-column align-items-center align-content-center">
                    <a className="text-dark text-decoration-none" href={data.link}>
                    <img  className="instafeed-pictures rounded  align-content-center justify-content-center" src={data.images.low_resolution.url} alt={InstaTitle} /></a>
                    <div>
                      <a className="text-dark text-decoration-none" href={data.link}>
                      <span className="font-weight-bold text-center">{InstaTitle}</span>
                      <span className="font-weight-bold">{InstaHasAt}</span>
                      </a>
                    </div>
                    <div className="mt-1">
                    <span className="small">{InstaHasTags}</span>
                    </div>
                  </div>
           })}
          </div>
        </div>

      )
  }
}

export default Feed;